/* globals: wc_bookings_admin_calendar_js_params */

/**
 * External dependencies
 */
import { render } from '@wordpress/element';
import { forEach } from 'lodash';

/**
 * Internal dependencies.
 */
import StoreAvailabilityPopover from './components/store-availability-popover';

let popoverContainer;

const storeAvailabilityDays = document.getElementsByClassName( 'wc-bookings__store-availability-day' );

if ( null !== storeAvailabilityDays ) {
	forEach( storeAvailabilityDays, ( storeAvailabilityDay ) => {
		storeAvailabilityDay.addEventListener( 'click', () => {
			const date = new Date( parseInt( storeAvailabilityDay.dataset.timestamp ) * 1000 /* to milliseconds */ );

			if ( popoverContainer ) {
				document.body.removeChild( popoverContainer );
			}
 	 	 	popoverContainer = document.createElement( 'div' );
			document.body.appendChild( popoverContainer );

			render(<StoreAvailabilityPopover selectedDate={ date }/>, popoverContainer);
		} );
	} )
}
